<style>
#documentationRegister .v--modal-box.v--modal {
  min-height: 350px !important;
  min-width: 600px !important;
}
#documentationRegister .modal__footer {
  display: none !important;
}
</style>

<template>
  <Modal
    modalName="documentationRegister"
    title="Rejestr dokumentacji pojektowej"
    :buttons="[]"
  >
    <DocumentationTable />
  </Modal>
</template>

<script>
import Modal from "../../../shared/Modal";
import DocumentationTable from "../../table/investments/DocumentationTable.vue";

export default {
  components: {
    Modal,
    DocumentationTable
  },
  data: () => ({
  }),
  computed: {},
  methods: {}
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/management/modals/DocumentationRegister.vue